import _objectSpread from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
export var sanitizeChannelSplitterOptions = function sanitizeChannelSplitterOptions(options) {
  return _objectSpread({}, options, {
    channelCount: options.numberOfOutputs
  });
};